import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../lib/api";
import PublicNav from "../../components/PublicNav";
import Footer from "../../components/Footer";
import { CheckCircle, Warning, Clock } from "@phosphor-icons/react";

export default function WaitlistClaim() {
  const { token } = useParams();
  const nav = useNavigate();
  const [state, setState] = useState({ loading: true, ok: false, error: null, data: null });

  useEffect(() => {
    api.get(`/waitlist/${token}`)
      .then(r => setState({ loading: false, ok: true, data: r.data }))
      .catch(e => setState({ loading: false, ok: false, error: e?.response?.data?.detail || "Lock invalid or expired" }));
  }, [token]);

  const goToCheckout = () => {
    if (state.data?.instance_id) {
      nav(`/checkout/${state.data.instance_id}?waitlist_token=${token}`);
    }
  };

  return (
    <div className="public-shell">
      <PublicNav />
      <section className="bg-ms-cream pt-32 pb-24 min-h-[70vh]" data-testid="waitlist-claim">
        <div className="max-w-2xl mx-auto px-6 md:px-12 text-center">
          {state.loading && <p className="text-ms-stone">Checking your lock…</p>}
          {!state.loading && state.ok && (
            <div>
              <CheckCircle size={56} weight="fill" className="text-ms-success mx-auto" />
              <p className="label-eyebrow text-ms-brass mt-6 flex items-center justify-center gap-1.5"><Clock size={12} weight="duotone" /> Your 30-minute window is open</p>
              <h1 className="serif text-ms-ink text-4xl md:text-5xl mt-3">A seat is yours to claim, {state.data.name.split(" ")[0]}.</h1>
              <div className="mt-6 bg-ms-ivory border border-ms-edge rounded-md p-5 text-left max-w-md mx-auto">
                <p className="text-ms-stone text-xs label-eyebrow">Tour</p>
                <p className="text-ms-ink text-lg serif">{state.data.tour?.title}</p>
                <p className="text-ms-stone text-sm mt-2">{new Date(state.data.instance.starts_at).toLocaleString(undefined, {weekday:'long', month:'long', day:'numeric', hour:'numeric', minute:'2-digit'})}</p>
                <p className="text-ms-stone text-xs mt-3">Lock expires {new Date(state.data.lock_expires_at).toLocaleTimeString([], {hour:'numeric', minute:'2-digit'})}</p>
              </div>
              <button onClick={goToCheckout} className="mt-8 btn-primary" data-testid="waitlist-go-checkout">
                Claim my seat
              </button>
            </div>
          )}
          {!state.loading && !state.ok && (
            <div>
              <Warning size={48} weight="fill" className="text-ms-danger mx-auto" />
              <h1 className="serif text-3xl text-ms-ink mt-6">This lock isn't valid anymore</h1>
              <p className="mt-4 text-ms-stone">{state.error}</p>
              <p className="mt-4 text-ms-stone text-sm">If the date is still showing seats on the site, you can book directly.</p>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
